<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
  /* eslint-disable */
(function($, window, undefined) {

   var YoutubeIframeApiGlobal;

   var defaults = {
      youtubeApiKey: 'AIzaSyCDFYVvR9c_p_VgTaqlzEwXAo88_R3jyv8',
      maxListSize: 50,
      loadingClass: "embed-loading",
      errorMessage: "There was an error loading this video playlist.",
      playerVars: {
         autoplay: false, // Play first video automatically
         controls: 2, // Player control 0, 1, 2
         modestbranding: 0, // Show youtube logo
         rel: 0, // Show related videos
         showinfo: 1, // Show title and user info
         enablejsapi: 1, // Enable JS API
         origin: "https://www.macalester.edu"
      },
      slickSettings: {
         slidesToShow: 5, 
         infinite: false, 
         slidesToScroll: 1, 
         centerMode: true, 
         arrows: true,
         mobileFirst: true,
         responsive: [
            {
               breakpoint: 850, 
               settings: {
                  slidesToShow: 7 
               }
            } 
         ]
      }
   };

   var MacPlaylistLong = function(element, playlistId, options) {
      this.$elem = $(element);
      this.options = $.extend(true, {}, defaults, this.$elem.data(), options); 
      this.playlistId = playlistId || this.options.youtubePlaylistLong;
      this.player = this.$slider = this.videos = null;
      this.init();
   };

   MacPlaylistLong.prototype = {

      constructor: MacPlaylistLong,

      init: function() {
         this.$elem.empty().addClass(this.options.loadingClass);
         // Simultaneously load Youtube API and playlist videos 
         $.when(
            this._fetchYoutubeApiScripts(), // promise returns YT api object
            this._fetchPlaylistInfo(this.playlistId) // promise returns array of video objects
            )
            .done(this._drawPlaylist.bind(this))
            .fail(this._errorMessage.bind(this))
      },

      _drawPlaylist: function(ytApi, videos) {
         var $playerElem = $("<div>").addClass("video-wrapper playlist-player");
         this.$slider = $("<div>").css('margin-top', '20px');
         this.$elem.html([$playerElem, this.$slider]);
         this.videos = videos;
         return this._createPlayer($playerElem, videos, ytApi)
            .done(
               function(player) {
                 this.player = player;
                 this.$slider = this._createSlider(this.$slider, videos);
                 this._syncUpEvents(this.$slider, this.player, ytApi);
                 this.$elem.removeClass(this.options.loadingClass);
               }.bind(this)
            );
      },

      _syncUpEvents: function($slider, player, ytApi) {

         function updateSlider(index) {
            //   if ($slider.slick('slickCurrentSlide') !== index)
            //   $slider.slick('slickGoTo', index);
         }

         function updatePlayer(index) {
            if (player.getPlaylistIndex() !== index) {
               setTimeout(function() { 
                  player.playVideoAt(index)
               }, 500);
            }
             /*$('html, body').animate({
                 scrollTop: $("#player").scrollTop()
                 //scrollTop: $("#player").offset().top
             }, 500);*/
         }

         //BB
         var urlVideoIndex = getUrlParameter('video');
         console.log("Video Index:" + urlVideoIndex);
         if (urlVideoIndex != null){
            urlVideoIndex--;
            updatePlayer(urlVideoIndex);
         }
         //BB

	 if (getUrlParameter('videoid')) {
	    var selectedIndex = this.videos.findIndex(function (vid) {
	       return vid.id === getUrlParameter('videoid');
	    });
	    console.log(selectedIndex);
	    if (selectedIndex > -1) {
	       updatePlayer(selectedIndex);
	    }
	 }

         player.addEventListener("onStateChange", function(e) {
            if (e.data == ytApi.PlayerState.PLAYING) {
               updateSlider(e.target.getPlaylistIndex());
               this.$elem.trigger($.Event("videoPlay", this.videos[e.target.getPlaylistIndex()]));
            }
         }.bind(this));

         $slider.delegate("a", "click", function(e) {
            var index = $(e.currentTarget).attr("data-video-index");
            //e.preventDefault();
            //BB
            if ((e.currentTarget).hasAttribute("data-video-index") == false){
            	//console.log("link found");
            }
            else{
            	e.preventDefault();
            	updatePlayer(index);
            	$('html, body').animate({
                	scrollTop: (($("#player").offset().top)-100)
             	}, 500);
            	this.$elem.trigger($.Event("videoSelect", this.videos[index]));
            }
            //BB
            //$slider.find(".highlight").removeClass("highlight");
            //$(e.currentTarget).closest("li").addClass("highlight");
            //updatePlayer(index);
            //$slider.slick('slickGoTo', index);
            //this.$elem.trigger($.Event("videoSelect", this.videos[index]));
         }.bind(this));

         //$slider.on('beforeChange', function(event, slick, currentSlide, next){
            //updatePlayer(next);
         //});

      },

      _errorMessage: function(args) {
         console.log("Caught error in promise ", args)
         var eventDetail = Array.prototype.slice.call(arguments);
         var message = "Unknown Error";
         if (message = $.parseJSON(args.responseText).error.message) {
            // (request includes details in JSON body)
         } else if (message = args.message) {
            // (error was passed as first argument) 
         }
         this.$elem.removeClass(this.options.loadingClass);
         this.$elem.trigger($.Event("error", {message: message, errorDetails: args}));
         $("<div>").addClass("card card-error error")
            .append($("<h1>").text("Sorry"))
            .append($("<p>").text(this.options.errorMessage))
            .appendTo(this.$elem);
      },

      _createSlider: function($elem, videos) {
         var $videoList = $('<ul>').addClass('fact-list small-image-list').appendTo($elem);
         $.each(videos, function(index, vid) {
            var $desc = vid.description.replace("(","<br><em style='color:#5b6770;'>").replace(")","</em>").replace("[","<div style='display:none;'").replace("]","</div>"); //BB
            $desc = linkify($desc); //BB
            var $li = $('<li>').appendTo($videoList);
            $li; 
            $li.append($("<a>").attr({"href": vid.videoURL, "title": vid.title, "data-video-index": index, "data-video-id": vid.id})
                                    .append($("<img>").attr("src", vid.thumb))
                                    .append($('<strong>').text(vid.title)));
            $li.append($('<br>'));
            //$li.append(vid.description);
            $li.append($desc); //BB
         });
         return $elem;
      },

      // Promise
      _createPlayer: function(elem, videos, ytApi) {
         var returnDeferred = $.Deferred();
         var player = new ytApi.Player($("<div>").appendTo(elem).get(0), {
            playerVars: this.options.playerVars,
            events: {
               onReady: function(e) {
                     var vidArray = $.map(videos, function(i){return i.id;});
                     player.cuePlaylist(vidArray);
                     returnDeferred.resolve(player);
                  }
            }
         });
         window.player = player;
         return returnDeferred.promise();
      },

      // Promise
      _fetchYoutubeApiScripts: function() {
         if(!YoutubeIframeApiGlobal) {
            YoutubeIframeApiGlobal = $.Deferred(function(defer) {
               var loadTimeout = window.setTimeout(function(){
                  defer.reject("Timeout error retrieving Youtube API script"); 
               }, 5000);
               window.onYouTubeIframeAPIReady = function() {
                  window.clearTimeout(loadTimeout);
                  defer.resolve(YT);
               };
               $.getScript('https://www.youtube.com/iframe_api').then(null, defer.reject);
            });
         }
         return YoutubeIframeApiGlobal.promise();
      },

      // Promise
      _fetchPlaylistInfo: function(playlistId) {
         var playListURL = 'https://www.googleapis.com/youtube/v3/playlistItems';
         var reqData = {maxResults: this.options.maxListSize, part: "snippet", playlistId: playlistId, key: this.options.youtubeApiKey};
         return $.getJSON(playListURL, reqData)
            .then(function(data) {
               return $.map(data.items, function(item) {
                  var videoID = item.snippet.resourceId.videoId;
                  return {
                     id: videoID,
                     title: item.snippet.title,
                     description: item.snippet.description || "",
                     descriptionFormat: "text" || "",
                     link: '',
                     embedURL: "https://www.youtube.com/embed/" + videoID,
                     videoURL: "https://www.youtube.com/watch?v=" + videoID,
                     image: item.snippet.thumbnails.hasOwnProperty('maxres') ? item.snippet.thumbnails.maxres.url : item.snippet.thumbnails.high.url,
                     thumb: item.snippet.thumbnails['default'].url
                     };
                  });
            });
      }
   };

   function Plugin(playlistId, options) {
      $(this).each(function() {
         var $this = $(this);
         var data = $this.data('mac.playlist');
         if (!data) $this.data('mac.playlist', (data = new MacPlaylistLong(this, playlistId, options)));
      });
   }   

   $.fn.macPlaylistLong = Plugin;

   // Support declarative syntax 
   $(function() {
      $('[data-youtube-playlist-long]').macPlaylistLong();
   });

   //BB
   function getUrlParameter(name) {
       name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
       var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
       var results = regex.exec(location.search);
       return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
   };

   function linkify(text) {
        var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(exp, "<i><a href='$1'>More about this academic program >></a></i>");
        //return text.replace(exp, "<a href='$1' target='_blank' rel="noopener noreferrer">$1</a>");
   };
   //BB

})(jQuery, window);

    /* eslint-enable */
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/YoutubePlaylist.vue